import * as i0 from '@angular/core';
import { Directive, HostBinding, Input, NgModule } from '@angular/core';
import { IspuiDropdownContent } from '@ispui/dropdown/dist/components/ispui-dropdown-content.js';
import { IspuiDropdownFooter } from '@ispui/dropdown/dist/components/ispui-dropdown-footer.js';
import { IspuiDropdownHeader } from '@ispui/dropdown/dist/components/ispui-dropdown-header.js';
import { IspuiDropdownPopup } from '@ispui/dropdown/dist/components/ispui-dropdown-popup.js';
import { IspuiDropdown } from '@ispui/dropdown/dist/components/ispui-dropdown.js';

class ISPUIDropdownValueAccessor {
    constructor(elRef) {
        this.elRef = elRef;
    }
}
ISPUIDropdownValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIDropdownValueAccessor, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
ISPUIDropdownValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ISPUIDropdownValueAccessor, selector: "ispui-dropdown", inputs: { zIndex: ["z-index", "zIndex"], isClose: ["is-close", "isClose"], hasPointer: ["has-pointer", "hasPointer"], strictDirection: ["strict-direction", "strictDirection"], closeAfterClick: ["close-after-click", "closeAfterClick"], disabled: "disabled", type: "type", direction: "direction", alignment: "alignment", closeOnOuterClick: "closeOnOuterClick", hoverDebounce: ["hover-debounce", "hoverDebounce"], offset: "offset", parentSelector: "parentSelector", scrollSelector: "scrollSelector", borderOffset: ["border-offset", "borderOffset"], pointerHeight: ["pointer-height", "pointerHeight"], pointerWidth: ["pointer-width", "pointerWidth"], pointerOffset: ["pointer-offset", "pointerOffset"], popupClass: ["popup-class", "popupClass"], directionOrder: ["direction-order", "directionOrder"], alignmentOrder: ["alignment-order", "alignmentOrder"] }, host: { properties: { "attr.z-index": "this.zIndex", "attr.is-close": "this.isClose", "attr.has-pointer": "this.hasPointer", "attr.strict-direction": "this.strictDirection", "attr.close-after-click": "this.closeAfterClick", "attr.disabled": "this.disabled", "attr.type": "this.type", "attr.direction": "this.direction", "attr.alignment": "this.alignment", "attr.close-on-outer-click": "this.closeOnOuterClick", "attr.hover-debounce": "this.hoverDebounce", "attr.offset": "this.offset", "attr.parent-selector": "this.parentSelector", "attr.scroll-selector": "this.scrollSelector", "attr.border-offset": "this.borderOffset", "attr.pointer-height": "this.pointerHeight", "attr.pointer-width": "this.pointerWidth", "attr.pointer-offset": "this.pointerOffset", "attr.popup-class": "this.popupClass", "directionOrder": "this.directionOrder", "alignmentOrder": "this.alignmentOrder" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIDropdownValueAccessor, decorators: [{
            type: Directive,
            args: [{ selector: 'ispui-dropdown' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { zIndex: [{
                type: HostBinding,
                args: ['attr.z-index']
            }, {
                type: Input,
                args: ['z-index']
            }], isClose: [{
                type: HostBinding,
                args: ['attr.is-close']
            }, {
                type: Input,
                args: ['is-close']
            }], hasPointer: [{
                type: HostBinding,
                args: ['attr.has-pointer']
            }, {
                type: Input,
                args: ['has-pointer']
            }], strictDirection: [{
                type: HostBinding,
                args: ['attr.strict-direction']
            }, {
                type: Input,
                args: ['strict-direction']
            }], closeAfterClick: [{
                type: HostBinding,
                args: ['attr.close-after-click']
            }, {
                type: Input,
                args: ['close-after-click']
            }], disabled: [{
                type: HostBinding,
                args: ['attr.disabled']
            }, {
                type: Input
            }], type: [{
                type: HostBinding,
                args: ['attr.type']
            }, {
                type: Input
            }], direction: [{
                type: HostBinding,
                args: ['attr.direction']
            }, {
                type: Input
            }], alignment: [{
                type: HostBinding,
                args: ['attr.alignment']
            }, {
                type: Input
            }], closeOnOuterClick: [{
                type: HostBinding,
                args: ['attr.close-on-outer-click']
            }, {
                type: Input
            }], hoverDebounce: [{
                type: HostBinding,
                args: ['attr.hover-debounce']
            }, {
                type: Input,
                args: ['hover-debounce']
            }], offset: [{
                type: HostBinding,
                args: ['attr.offset']
            }, {
                type: Input
            }], parentSelector: [{
                type: HostBinding,
                args: ['attr.parent-selector']
            }, {
                type: Input
            }], scrollSelector: [{
                type: HostBinding,
                args: ['attr.scroll-selector']
            }, {
                type: Input
            }], borderOffset: [{
                type: HostBinding,
                args: ['attr.border-offset']
            }, {
                type: Input,
                args: ['border-offset']
            }], pointerHeight: [{
                type: HostBinding,
                args: ['attr.pointer-height']
            }, {
                type: Input,
                args: ['pointer-height']
            }], pointerWidth: [{
                type: HostBinding,
                args: ['attr.pointer-width']
            }, {
                type: Input,
                args: ['pointer-width']
            }], pointerOffset: [{
                type: HostBinding,
                args: ['attr.pointer-offset']
            }, {
                type: Input,
                args: ['pointer-offset']
            }], popupClass: [{
                type: HostBinding,
                args: ['attr.popup-class']
            }, {
                type: Input,
                args: ['popup-class']
            }], directionOrder: [{
                type: HostBinding,
                args: ['directionOrder']
            }, {
                type: Input,
                args: ['direction-order']
            }], alignmentOrder: [{
                type: HostBinding,
                args: ['alignmentOrder']
            }, {
                type: Input,
                args: ['alignment-order']
            }] } });

class ISPUIDropdownContentValueAccessor {
}
ISPUIDropdownContentValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIDropdownContentValueAccessor, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ISPUIDropdownContentValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ISPUIDropdownContentValueAccessor, selector: "ispui-dropdown-content", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIDropdownContentValueAccessor, decorators: [{
            type: Directive,
            args: [{ selector: 'ispui-dropdown-content' }]
        }] });

class ISPUIDropdownContentLazyValueAccessor {
    constructor(templateRef, vcr, dropdown) {
        this.templateRef = templateRef;
        this.vcr = vcr;
        this.dropdown = dropdown;
        this.openListener = () => {
            this.closeListener();
            this.viewRef = this.vcr.createEmbeddedView(this.templateRef);
            this.viewRef.detectChanges();
            this.dropdownEl?.setupDropdown();
        };
        this.closeListener = () => {
            if (this.viewRef) {
                this.viewRef.destroy();
                this.viewRef = undefined;
            }
        };
        if (this.dropdownEl) {
            this.dropdownEl.addEventListener('open', this.openListener);
            this.dropdownEl.addEventListener('close', this.closeListener);
        }
    }
    get dropdownEl() {
        return this.dropdown?.elRef?.nativeElement;
    }
    ngOnDestroy() {
        if (this.dropdownEl) {
            this.dropdownEl.removeEventListener('open', this.openListener);
            this.dropdownEl.removeEventListener('close', this.closeListener);
        }
        this.closeListener();
    }
}
ISPUIDropdownContentLazyValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIDropdownContentLazyValueAccessor, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: ISPUIDropdownValueAccessor }], target: i0.ɵɵFactoryTarget.Directive });
ISPUIDropdownContentLazyValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ISPUIDropdownContentLazyValueAccessor, selector: "[ispuiDropdownContentLazy]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIDropdownContentLazyValueAccessor, decorators: [{
            type: Directive,
            args: [{ selector: '[ispuiDropdownContentLazy]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: ISPUIDropdownValueAccessor }]; } });

class ISPUIDropdownHeaderValueAccessor {
}
ISPUIDropdownHeaderValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIDropdownHeaderValueAccessor, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ISPUIDropdownHeaderValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ISPUIDropdownHeaderValueAccessor, selector: "ispui-dropdown-header", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIDropdownHeaderValueAccessor, decorators: [{
            type: Directive,
            args: [{ selector: 'ispui-dropdown-header' }]
        }] });

class ISPUIDropdownFooterValueAccessor {
}
ISPUIDropdownFooterValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIDropdownFooterValueAccessor, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ISPUIDropdownFooterValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ISPUIDropdownFooterValueAccessor, selector: "ispui-dropdown-footer", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIDropdownFooterValueAccessor, decorators: [{
            type: Directive,
            args: [{ selector: 'ispui-dropdown-footer' }]
        }] });

class ISPUIDropdownModule {
    constructor() {
        if (typeof customElements !== 'undefined') {
            [IspuiDropdown, IspuiDropdownContent, IspuiDropdownFooter, IspuiDropdownHeader, IspuiDropdownPopup].forEach((comp) => {
                if (!customElements.get(comp.is)) {
                    customElements.define(comp.is, comp);
                }
            });
        }
    }
}
ISPUIDropdownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIDropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ISPUIDropdownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIDropdownModule, declarations: [ISPUIDropdownValueAccessor,
        ISPUIDropdownContentValueAccessor,
        ISPUIDropdownContentLazyValueAccessor,
        ISPUIDropdownFooterValueAccessor,
        ISPUIDropdownHeaderValueAccessor], exports: [ISPUIDropdownValueAccessor,
        ISPUIDropdownContentValueAccessor,
        ISPUIDropdownContentLazyValueAccessor,
        ISPUIDropdownFooterValueAccessor,
        ISPUIDropdownHeaderValueAccessor] });
ISPUIDropdownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIDropdownModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ISPUIDropdownValueAccessor,
                        ISPUIDropdownContentValueAccessor,
                        ISPUIDropdownContentLazyValueAccessor,
                        ISPUIDropdownFooterValueAccessor,
                        ISPUIDropdownHeaderValueAccessor,
                    ],
                    exports: [
                        ISPUIDropdownValueAccessor,
                        ISPUIDropdownContentValueAccessor,
                        ISPUIDropdownContentLazyValueAccessor,
                        ISPUIDropdownFooterValueAccessor,
                        ISPUIDropdownHeaderValueAccessor,
                    ],
                }]
        }], ctorParameters: function () { return []; } });

/**
 * Generated bundle index. Do not edit.
 */

export { ISPUIDropdownContentLazyValueAccessor, ISPUIDropdownContentValueAccessor, ISPUIDropdownFooterValueAccessor, ISPUIDropdownHeaderValueAccessor, ISPUIDropdownModule, ISPUIDropdownValueAccessor };
